import Link from 'components/common/Link/Link';

type NoEventsFoundProps = {
  message?: string;
};

const NoEventsFound = ({ message }: NoEventsFoundProps): JSX.Element => (
  <div>
    <h3 className="PowerQueries__InvalidTextHeader">{message ? message : 'No matching events found.'}</h3>
    <div className="PowerQueries__InvalidTextDescription">
      {'↳You can use your browser’s Back button to see the previous results, or click '}
      <Link className="link" href="/query" openInNewTab>
        here
      </Link>
      {' to start a new search.'}
    </div>
  </div>
);

export default NoEventsFound;
